/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Why_Listening_Authors_CountInputs */

const en_why_listening_authors_count = /** @type {(inputs: Why_Listening_Authors_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} authors`)
};

const es_why_listening_authors_count = /** @type {(inputs: Why_Listening_Authors_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} autores`)
};

/**
* | output |
* | --- |
* | "{count} authors" |
*
* @param {Why_Listening_Authors_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_authors_count = /** @type {((inputs: Why_Listening_Authors_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Authors_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_authors_count(inputs)
	return en_why_listening_authors_count(inputs)
});